import { ListRow, Text } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';
import { Flex } from '@betterment/samba-styled-system/jsx';
import { SambaAutoLink } from '@betterment/shared-components';

import { urlBuilder } from '../../Shared/urlBuilder';
import { HomeProductOnboardingOptionsQuery } from '../graphql/homeProductOnboardingOptions.generated';

type Props = { intent: HomeProductOnboardingOptionsQuery['goalCreationIntents'][number] };

export const GoalCreationIntentRow: React.FC<Props> = ({ intent }) => (
  <ListRow>
    <ListRow.LeadingContent>
      <Flex flexDirection="row" alignItems="center">
        <img
          src={intent.icon.light}
          alt={intent.name}
          className={css({ width: '36px', marginLeft: 'space.100', marginRight: 'space.150' })}
        />
        <Text>{intent.name}</Text>
      </Flex>
    </ListRow.LeadingContent>
    <ListRow.TrailingContent>
      <SambaAutoLink
        variant="solidSecondary"
        spacing="compact"
        to={urlBuilder.appGoalCreationIntents.absolute({ goalCreationIntentId: intent.id })}
      >
        Finish set up
      </SambaAutoLink>
    </ListRow.TrailingContent>
  </ListRow>
);
